import { classNames } from "primereact/utils"
import { useDispatch } from "react-redux"
import { setTime } from "../../../../../stateManagement/reducers/maps/MapGismeteoPrecipitationSlice";

export type TimeMarkProps = {
    time: Date,
    caption: string,
    index: number,
    active: boolean
}

export default function TimeMark({ time, caption, index, active }: TimeMarkProps) {
    const dispatch = useDispatch();

    const timeMarkClassnames = classNames({
        "time-mark": true,
        "active": active
    })

    function changeChosenTime() {
        dispatch(setTime({time: time.toISOString(), timeMarkIndex: index}))
    }

    return (
        <div className={timeMarkClassnames} onClick={changeChosenTime}>
            {caption}
        </div>
    )
}
